export default {
    keepOnHover: true,
    fullWidth: true,
    fitToScreen: true,
    theme: 'bubble',
    duration: 6000,
    singleton: true,
  }
  